import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  CreateMetadataParams,
  UpdateMetadataParams,
  MetadataData,
  DeleteMetadataParams,
} from "./interface";
import { API_URLS } from "../../../constants";

const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

// Create metadata
export const createMetadata = async (
  params: CreateMetadataParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<null>>(
      API_URLS.METADATA.CREATE_METADATA,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating metadata:", error);
    throw error;
  }
};

// Get metadata by company ID
export const getMetadataByCompanyId = async (
  companyId: string
): Promise<ApiResponse<MetadataData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<MetadataData[]>>(
      `${API_URLS.METADATA.GET_METADATA_BY_COMPANY_ID}/${companyId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching metadata:", error);
    throw error;
  }
};

// Update metadata
export const updateMetadata = async (
  params: UpdateMetadataParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.patch<ApiResponse<null>>(
      API_URLS.METADATA.UPDATE_METADATA,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating metadata:", error);
    throw error;
  }
};

// Delete metadata
export const deleteMetadata = async (
  params: DeleteMetadataParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.METADATA.DELETE_METADATA,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: params,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting metadata:", error);
    throw error;
  }
};

// Get metadata types
export const getMetadataTypes = async (): Promise<ApiResponse<string[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<string[]>>(
      API_URLS.METADATA.GET_METADATA_TYPES,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching metadata types:", error);
    throw error;
  }
};
